module.exports = __webpack_public_path__ + "img/ge.08c96bbb.svg";